/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Analysis_DescriptionInputs */

const en_onboarding_analysis_description = /** @type {(inputs: Onboarding_Analysis_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We've analyzed your preferences and created a personalized reading experience for you.`)
};

const es_onboarding_analysis_description = /** @type {(inputs: Onboarding_Analysis_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos analizado tus preferencias y creado una experiencia de lectura personalizada para ti.`)
};

/**
* | output |
* | --- |
* | "We've analyzed your preferences and created a personalized reading experience for you." |
*
* @param {Onboarding_Analysis_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_analysis_description = /** @type {((inputs?: Onboarding_Analysis_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Analysis_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_analysis_description(inputs)
	return en_onboarding_analysis_description(inputs)
});